import { defineAsyncComponent } from 'vue'

export const blockDefinitions = {
  accordion_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/AccordionBlock.vue')
    ),
    fields: ['*.*.*']
  },
  chapter_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/ChapterBlock.vue')
    ),
    fields: ['*.*']
  },
  conversion_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/ConversionBlock.vue')
    ),
    fields: ['*.*']
  },
  downloads_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/DownloadsBlock.vue')
    ),
    fields: ['*.*.*']
  },
  episodes_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/EpisodesBlock.vue')
    ),
    fields: ['*.*.*']
  },
  form_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/FormBlock.vue')
    ),
    fields: ['*.*.*.*']
  },
  grid_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/GridBlock.vue')
    ),
    fields: ['*', 'related_to.collection', 'related_to.item.id', 'related_to.item.title']
  },
  grid_latest_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/GridBlockStatic.vue')
    ),
    additionalProps: { variant: 'new' },
    fields: ['*', 'related_to.collection', 'related_to.item.id']
  },
  highlight_article_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightArticleBlock.vue')
    ),
    fields: [
      '*',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.domain.*.*',
      'highlight.slug',
      'highlight.belongs_to.item.*',
      'highlight.image'
    ]
  },
  highlight_content_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightContentBlock.vue')
    ),
    fields: [
      '*',
      'button_label',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.slug',
      'highlight.belongs_to.*',
      'highlight.domain.*.*'
    ]
  },
  highlight_longread_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightLongreadBlock.vue')
    ),
    fields: [
      '*',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.domain.*.*',
      'highlight.slug',
      'highlight.belongs_to.item.*',
      'highlight.image',
      'highlight.reading_time'
    ]
  },
  highlight_short_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightShortBlock.vue')
    ),
    fields: [
      '*',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.domain.*.*',
      'highlight.slug',
      'highlight.belongs_to.item.*',
      'highlight.image',
      // TODO: @frankd phase out mp4 & hls fields
      'highlight.mp4',
      'highlight.hls',
      'highlight.youtube_short_id',
      'highlight.animated_gif',
      'highlight.video_time'
    ]
  },
  highlight_story_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightStoryBlock.vue')
    ),
    fields: [
      '*',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.domain.*.*',
      'highlight.slug',
      'highlight.belongs_to.item.*',
      'highlight.image',
      'highlight.tappable_url'
    ]
  },
  highlight_video_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/HighlightVideoBlock.vue')
    ),
    fields: [
      '*',
      'highlight.id',
      'highlight.status',
      'highlight.title',
      'highlight.domain.*.*',
      'highlight.slug',
      'highlight.belongs_to.item.*',
      'highlight.image'
    ]
  },
  image_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/ImageBlock.vue')
    ),
    fields: ['*']
  },
  image_carousel_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/ImageCarouselBlock.vue')
    ),
    fields: ['*.*.*']
  },
  persons_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/PersonsBlock.vue')
    ),
    fields: [
      '*',
      '*.people_page.slug',
      'persons.person_page.id',
      'persons.person_page.status',
      'persons.person_page.title',
      'persons.person_page.subtitle',
      'persons.person_page.slug',
      'persons.person_page.image',
      'persons.person_page.domain.*.*',
      'people_page.slug',
      'people_page.status'
    ]
  },
  newsletter_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/NewsletterBlock.vue')
    ),
    fields: ['*']
  },
  poll_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/PollBlock.vue')
    ),
    fields: ['*.*.*']
  },
  programs_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/ProgramsBlock.vue')
    ),
    fields: [
      '*',
      '*.program_page.status',
      '*.program_page.title',
      '*.program_page.image',
      '*.program_page.id',
      '*.program_page.slug',
      '*.program_page.external_url',
      '*.program_page.type.*',
      '*.program_page.domain.color.*'
    ]
  },
  riddle_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/RiddleBlock.vue')
    ),
    fields: [
      '*'
    ]
  },
  afas_section_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/AfasSectionBlock.vue')
    ),
    fields: [
      '*'
    ]
  },
  vacancy_grid_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks/VacancyGridBlock.vue')
    ),
    fields: [
      '*'
    ]
  }
}
